<template>
  <div class="content sepultamentos p-1">
    <h4 class="sepultamentos_title">
      <b>Locais de sepultamento</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row align-h="between">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label
              for="busca"
              class="sepultamentos_label">Buscar Local</label>
            <input
              id="busca"
              v-model="search"
              class="col-md-12 form-control form-control-sm"
              name="busca"
              placeholder="Digite o nome do local para pesquisa"
              type="text">
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button
              variant="secondary"
              size="sm"
              @click="showModal()">
              <svg
                class="button_edit_label_icon icon--xxs"
                role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar local
            </b-button>
          </div>
        </div>
      </b-row>

      <Table
        :fields="fields"
        :data="sepultamentos"
        :is-busy="isBusy"
        :search="search"
        field-search="nome"
        @showModal="showModal"
        @onUpdateAtivo="updateAtivo"
        @deleteItem="deleteSepultamento" />
    </div>

    <Pagination
      :per-page="perPage"
      :page="page"
      :last-page="lastPage"
      @onPreviousPage="previousPage"
      @onNextPage="nextPage" />

    <form
      autocomplete="off"
      class="no-padding"
      @submit.prevent="callMethod()">
      <BoxModal
        :read="read"
        :form="form"
        :tipo="'Local de Sepultamento'"
        @changeRead="changeRead"
        @onEnderecoAdd="changeData" />
    </form>
  </div>
</template>

<script>

  /* components */
  import Pagination from "@/components/SofiaRei/Pagination"
  import Table from "@/components/SofiaRei/Table"
  import BoxModal from "@/components/SofiaRei/Cruds/BoxModal"

  /* services */
  import SepultamentoSugestaoService from "@/services/Registros/Obito/SepultamentoSugestaoService"

  /* assets */
  import excludeIcon from "@/assets/icons/ic_delete_24px.svg?sprite"
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"
  import add from '@/assets/icons/add.svg?sprite'

  /* outros */
  import debounce from 'lodash/debounce'
  import { mapGetters } from 'vuex'

  export default {
    name: "LocaisSepultamento",
    components: {
      Pagination,
      Table,
      BoxModal,
    },
    data () {
      return {
        search: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        excludeIcon,
        editIcon,
        eyeIcon,
        add,
        read: false,
        title: 'Nova funerária',
        fields: [{
          key: 'id',
          label: 'Ativo'
        },{
          key: 'nome',
          label: 'Nome'
        },{
          key: 'telefone',
          label: 'Telefone'
        },{
          key: 'email',
          label: 'Email'
        },{
          key: 'endereco.uf',
          label: 'Estado'
        },{
          key: 'endereco.cidade',
          label: 'Cidade'
        },{
          key: 'acoes2',
          label: ''
        }],
        sepultamentos: [],
        form: {
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: null,
          email: null,
          telefone: null,
          ativo: 1,
          endereco: {
            cep: null,
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cidade: null,
            uf: null,
            codigo_ibge_id: null
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      search: function (newSearch, oldSearch) {
        this.isBusy = true
        this.viewWatch()
      },
    },
    beforeMount () {
      try {
        loader({ text: "Obtendo dados...", active: true })
        this.init()
      } catch (e) {
        loader({ text: "", active: false })
      }
    },
    created () {
      this.viewWatch = debounce(function () {
        this.searchSepultamento()
      }, 200)
    },
    methods: {
      async init () {
        const sepultamentoSugestoes = await SepultamentoSugestaoService.getSepultamentoSugestao({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: this.perPage,
          page: this.page
        })

        this.sepultamentos = sepultamentoSugestoes.data
        this.sepultamentos.map((s) => {
          if (s.telefone) {
            s.telefone = s.telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1)$2-$3")
          }
        })

        this.lastPage = sepultamentoSugestoes.lastPage
        this.isBusy = false

        loader({ text: "", active: false })
      },
      async showModal (sepultamento = { data: {}, read: false }) {
        const { data, read } = sepultamento
        this.read = read

        if (data && data.sepultamento_sugestao_id) {
          this.form = {
            sepultamento_sugestao_id: data.sepultamento_sugestao_id,
            nome: data.nome,
            email: data.email,
            telefone: data.telefone,
            ativo: data.ativo,
            endereco: data.endereco,
            editar: true
          }
        } else {
          this.form = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: null,
            email: null,
            telefone: null,
            ativo: 1,
            endereco: {
              cep: null,
              logradouro: null,
              numero: null,
              complemento: null,
              bairro: null,
              cidade: null,
              uf: null,
              codigo_ibge_id: null
            }
          }
        }

        this.$bvModal.show('modal-cadastro')
      },
      async callMethod () {
        this.$bvModal.hide('modal-cadastro')

        if (this.form.telefone) {
          this.form.telefone = this.form.telefone.replace(/[()-]/g,'')
        }

        this.form.sepultamento_sugestao_id ? this.updateSepultamento(this.form) : this.saveSepultamento(this.form)
      },
      async saveSepultamento (sepultamento) {
        loader({ text: "Aguarde...", active: true })

        try {
          await SepultamentoSugestaoService.storeSepultamentoSugestao(sepultamento)

          await this.init()

          this.displaySuccess('Salvo com sucesso!')
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: "", active: false })
        }
      },
      async updateSepultamento (sepultamento, alert = true) {
        loader({ text: "Aguarde...", active: true })

        try {
          sepultamento.cartorio_id = this.$store.state.auth.cartorio_id

          await SepultamentoSugestaoService.updateSepultamentoSugestao(sepultamento, sepultamento.sepultamento_sugestao_id)

          await this.init()

          if (alert) this.displaySuccess('Atualizado com sucesso!')
        }
        catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: "", active: false })
        }
      },
      async deleteSepultamento (sepultamento) {
        loader({ text: "Aguarde...", active: true })

        try {
          await SepultamentoSugestaoService.destroySepultamentoSugestao(sepultamento.sepultamento_sugestao_id)

          await this.init()

          this.displaySuccess('Excluido com sucesso!')
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: "", active: false })
        }
      },
      displaySuccess (title = null, text = null) {
        objSwal.success.title = title || 'Realizado com sucesso!'
        objSwal.success.text = text
        objSwal.success.html = ''
        return Swal.fire(objSwal.success)
      },
      displayError (title = null, text = null) {
        objSwal.error.title = title || 'Error, tente novamente!'
        objSwal.error.text = text
        objSwal.error.html = ''
        return Swal.fire(objSwal.error)
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      async searchSepultamento () {
        const sepultamentoSugestoes = await SepultamentoSugestaoService.getSepultamentoSugestao({
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.search
        })

        this.sepultamentos = sepultamentoSugestoes.data
        this.sepultamentos.map((s) => {
          if (s.telefone) {
            s.telefone = s.telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1)$2-$3")
          }
        })

        this.lastPage = sepultamentoSugestoes.lastPage
        this.isBusy = false
      },
      updateAtivo (data) {
        const obj = {
          ...data,
          cartorio_id: this.$store.state.auth.cartorio_id,
          ativo: !data.ativo,
        }

        if (obj.telefone) {
          obj.telefone = obj.telefone.replace(/[()-]/g,'')
        }

        this.updateSepultamento(obj, false)
      },
      changeRead () {
        this.read = !this.read
      },
      changeData (endereco) {
        this.form.endereco = endereco
      },
    }
  }
</script>

<style lang="scss" >
  @import "@/scss/_utilities/_exports";

  .button_edit_label_icon {
    fill: #fff;
  }

  .button_delete_label_icon {
    fill: #fff;
  }

  .sepultamentos{
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }
</style>
